import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { payrollService } from "../../services/payrollService";

/** Seçili ayın bordro satırları (preview: kaydedilmiş varsa snapshot, yoksa canlı hesap). */
export const fetchPayrollPreview = createAsyncThunk(
  "payroll/preview",
  async (month, { rejectWithValue }) => {
    try {
      const res = await payrollService.preview(month);
      return res.data.data; // PayrollResponse[]
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Bordro yüklenemedi");
    }
  }
);

export const runPayroll = createAsyncThunk(
  "payroll/run",
  async ({ month, finalize }, { rejectWithValue }) => {
    try {
      const res = await payrollService.run(month, finalize);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Bordro hesaplanamadı");
    }
  }
);

const payrollSlice = createSlice({
  name: "payroll",
  initialState: { rows: [], isLoading: false, error: null },
  reducers: {
    clearPayrollError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayrollPreview.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPayrollPreview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.rows = action.payload ?? [];
      })
      .addCase(fetchPayrollPreview.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(runPayroll.fulfilled, (state, action) => {
        state.rows = action.payload ?? [];
      });
  },
});

export const { clearPayrollError } = payrollSlice.actions;
export default payrollSlice.reducer;
